import React from 'react';
import { useSiteContent, Toast } from '../context/SiteContext';
import { CheckCircle, AlertCircle, Info, X } from 'lucide-react';

export const ToastContainer: React.FC = () => {
  const { toasts, removeToast } = useSiteContent();

  if (toasts.length === 0) return null;

  return (
    <div className="fixed top-4 right-4 z-[100] flex flex-col gap-2 pointer-events-none" role="alert" aria-live="assertive">
      {toasts.map((toast) => (
        <div 
          key={toast.id} 
          className={`pointer-events-auto flex items-center gap-3 px-4 py-3 rounded-lg shadow-lg border animate-in slide-in-from-right-full fade-in duration-300 min-w-[300px] backdrop-blur-md ${
            toast.type === 'success' ? 'bg-green-500/10 border-green-500/20 text-green-500' :
            toast.type === 'error' ? 'bg-red-500/10 border-red-500/20 text-red-500' :
            'bg-blue-500/10 border-blue-500/20 text-blue-500'
          }`}
        >
          {toast.type === 'success' && <CheckCircle size={18} />}
          {toast.type === 'error' && <AlertCircle size={18} />}
          {toast.type === 'info' && <Info size={18} />}
          
          <p className="text-sm font-bold flex-1">{toast.message}</p>
          
          <button onClick={() => removeToast(toast.id)} className="opacity-70 hover:opacity-100 transition-opacity p-1 hover:bg-black/5 dark:hover:bg-white/5 rounded">
            <X size={14} />
          </button>
        </div>
      ))}
    </div>
  );
};